
export const FISERV_SDK_URL = "https://commercehub-checkout.fiservapps.com/sdk/3.8.16/checkout.js";

export const loadFiservSDK = (customUrl) => {
  return new Promise((resolve, reject) => {
    if (window.fiserv?.components) {
      resolve();
      return;
    }
    const sdkUrl = FISERV_SDK_URL;
    const existing = document.querySelector(`script[src="${sdkUrl}"]`);
    if (existing) {
      existing.addEventListener("load", () => resolve());
      existing.addEventListener("error", () =>
        reject(new Error("Failed to load Fiserv SDK")),
      );
      return;
    }

    const script = document.createElement("script");
    script.src = FISERV_SDK_URL;
    script.async = true;

    script.onload = () => resolve();
    script.onerror = () => reject(new Error("Failed to load Fiserv SDK"));

    document.body.appendChild(script);
  });
};